import { Controller } from "@hotwired/stimulus"
import { formatNumber } from "../lib/number_helper"

export default class extends Controller {
  static targets = [
    "fieldset",
    "select",
    "container",
    "template",
    "yearToAddInput",
    "yearlyAmountDisplay",
    "quarterlyAmountDisplay",
    "deliveryTable",
  ]
  static values = { next: Number }

  connect() {
    this.showDeliveryTableForYear()
  }

  update() {
    const selectedYear = this.selectTarget.value

    this.fieldsetTargets.forEach((el) => {
      const year = el.dataset.year

      el.classList.toggle("hidden", year !== selectedYear)
    })

    this.calculateTotalAmounts()
    this.showDeliveryTableForYear()
  }

  calculateTotalAmounts(event) {
    const year = this.selectTarget.value
    this.calculateYearlyAmount(year)

    if (typeof event !== "undefined") {
      const quarter = event.target.dataset.quarter
      this.calculateQuarterlyAmount(quarter, year)
    } else {
      ;["1", "2", "3", "4"].forEach((quarter) => {
        this.calculateQuarterlyAmount(quarter, year)
      })
    }
  }

  calculateYearlyAmount(year) {
    this.yearlyAmountDisplayTarget.textContent = this.getTotal(year)
  }

  calculateQuarterlyAmount(quarter, year) {
    const target = this.quarterlyAmountDisplayTargets.find(
      (element) =>
        element.dataset.year === year && element.dataset.quarter === quarter,
    )

    if (target) {
      target.textContent = this.getTotal(this.selectTarget.value, quarter)
    }
  }

  getTotal(year, quarter) {
    let sum = 0

    this.fieldsetTargets.forEach((fieldset) => {
      if (
        fieldset.dataset.year !== year ||
        (typeof quarter !== "undefined" && fieldset.dataset.quarter !== quarter)
      ) {
        return
      }

      const predictedAmount = parseFloat(
        fieldset.querySelector('input[id$="predicted_amount"]').value,
      )
      const actualAmount = parseFloat(
        fieldset.querySelector('input[id$="actual_amount"]').value,
      )
      const amountToAdd =
        !isNaN(actualAmount) && actualAmount !== 0
          ? actualAmount
          : predictedAmount

      sum += amountToAdd || 0
    })

    return formatNumber(sum, {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3,
    })
  }

  addYear(event) {
    event.preventDefault()

    const year = this.yearToAddInputTarget.value

    if (year < 1900 || year > 2100) {
      return false
    }

    if ([...this.selectTarget.options].some((opt) => opt.value === year)) {
      if (this.selectTarget.tomselect) {
        this.selectTarget.tomselect.setValue(year, true)
      } else {
        this.selectTarget.value = year
      }
      this.update()

      return false
    }

    this.templateTargets.forEach((templateTarget, index) => {
      const wrapper = templateTarget.cloneNode(true)

      delete wrapper.dataset.template
      wrapper.classList.remove("hidden")
      wrapper.dataset.plantsTarget = "fieldset"
      wrapper.dataset.year = year

      const uniqueIndex = Date.now() + index

      wrapper.querySelectorAll("input").forEach((el) => {
        if (el.name) {
          el.name = el.name.replace(/\[\d+\]/g, `[${uniqueIndex}]`)
        }

        if (el.name && el.name.endsWith("[year]")) {
          el.value = year
        }
      })

      wrapper.querySelectorAll('input[type="number"]').forEach((el) => {
        const oldId = el.id
        const newId = oldId.replace(/\d+/g, `${uniqueIndex}`)
        const label = wrapper.querySelector(`label[for="${oldId}"]`)

        el.id = newId
        if (label) {
          label.setAttribute("for", newId)
        }
      })

      wrapper
        .querySelectorAll(
          '[data-plants-target="quarterlyAmountDisplayTemplate"]',
        )
        .forEach((el) => {
          el.dataset.plantsTarget = "quarterlyAmountDisplay"
          el.dataset.year = year
        })

      this.containerTarget.appendChild(wrapper)
    })

    if (this.selectTarget.tomselect) {
      this.selectTarget.tomselect.addOption({ value: year, text: year })
      this.selectTarget.tomselect.setValue(year, true)
    } else {
      const option = document.createElement("option")
      option.value = year
      option.textContent = year
      this.selectTarget.appendChild(option)
      this.selectTarget.value = year
    }

    this.update()
    this.calculateTotalAmounts()
  }

  showDeliveryTableForYear() {
    const selectedYear = this.selectTarget.value

    this.deliveryTableTargets.forEach((el) => {
      const year = el.dataset.year
      el.classList.toggle("hidden", year !== selectedYear)
    })
  }
}
